/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerSpecialCriteria } from './ScreenerSpecialCriteria';
import {
    ScreenerSpecialCriteriaFromJSON,
    ScreenerSpecialCriteriaFromJSONTyped,
    ScreenerSpecialCriteriaToJSON,
    ScreenerSpecialCriteriaToJSONTyped,
} from './ScreenerSpecialCriteria';

/**
 * 
 * @export
 * @interface FindAllSpecialCriteria200Response
 */
export interface FindAllSpecialCriteria200Response {
    /**
     * 
     */
    data?: Array<ScreenerSpecialCriteria>;
}

/**
 * Check if a given object implements the FindAllSpecialCriteria200Response interface.
 */
export function instanceOfFindAllSpecialCriteria200Response(value: object): value is FindAllSpecialCriteria200Response {
    return true;
}

export function FindAllSpecialCriteria200ResponseFromJSON(json: any): FindAllSpecialCriteria200Response {
    return FindAllSpecialCriteria200ResponseFromJSONTyped(json, false);
}

export function FindAllSpecialCriteria200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllSpecialCriteria200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScreenerSpecialCriteriaFromJSON)),
    };
}

export function FindAllSpecialCriteria200ResponseToJSON(json: any): FindAllSpecialCriteria200Response {
    return FindAllSpecialCriteria200ResponseToJSONTyped(json, false);
}

export function FindAllSpecialCriteria200ResponseToJSONTyped(value?: FindAllSpecialCriteria200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScreenerSpecialCriteriaToJSON)),
    };
}

